import PropTypes from 'prop-types'
import React, { useState } from 'react'
import SelectSearch from 'react-select-search'
import { hasLayers, hasSubCategories } from '../../../../lib/layers.js'
import { STATES_DATA, SIDEBAR_VIEWS } from '../../../../lib/constants'
import ghAnalytics from '../../../../lib/analytics'
import Search from '../../../../assets/svg/Feather/Search'
import styles from '../LayersContent.module.scss'

function LayersSearchBox(props) {
  // super simple search.
  let searchMap = {}
  props.layers.forEach((state) => {
    const categories = state.categories

    for (let category of categories) {
      if (hasLayers(category)) {
        const layers = category.layers
        layers.forEach((layer) => {
          const searchableQuery = layer.layerName.toLowerCase();
          const resultData = {
            title: state.stateName.replace(' ', '_'),
            description: category.categoryName + ', ' + layer.layerName,
            categoryName: category.categoryName,
            key: `${state.stateName}-${category.categoryName}-${layer.layerName}`,
            // category,
            // layer,
          }
          if (!searchMap[searchableQuery]) {
            searchMap[searchableQuery] = [];
          }

          searchMap[searchableQuery].push(resultData);
        });
      }

      if (hasSubCategories(category)) {
        category.subCategories.forEach((subCat) => {
          if (hasLayers(subCat)) {
            const layers = subCat.layers
            layers.forEach((layer) => {
              const searchableQuery = layer.layerName.toLowerCase();
              let resultData = {
                // title: state.stateName,
                title: state.stateName.replace(' ', '_'),
                description: category.categoryName + ', ' + subCat.subCategoryName + ', ' + layer.layerName,
                categoryName: category.categoryName,
                subCategoryName: subCat.subCategoryName,
                key: `${state.stateName}-${category.categoryName}-${subCat.subCategoryName}-${layer.layerName}`,
                // category,
                // subCategory: subCat,
                // layer,
              };

              resultData.name = resultData.key;
              resultData.value = resultData.key;
              if (!searchMap[searchableQuery]) {
                searchMap[searchableQuery] = [];
              }

              searchMap[searchableQuery].push(resultData);
            })
          }
        })
      }
    }
  })

  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  const handleResultSelect = (event, data) => {
    ghAnalytics.logLayerSearchUsed(data.title, data.categoryName);
    props.dispatch({
      type: 'layers/setSelectedLayerCategory',
      payload: {
        stateName: data.title.replace('_', ' '),
        categoryName: data.categoryName,
        categoryIsOpen: true
      }
    });

    props.dispatch({
      type: 'app/gotoSidebarWithHistory',
      payload: SIDEBAR_VIEWS.LayerCategoryList,
    });

    const isSpecialEventLayer = ['tac', 'total archery challenge'].includes(data.title.toLowerCase())
    if (!isSpecialEventLayer) {
      props.dispatch({
        type: 'map/geocodeMapCenter',
        callback: (mapCenterInfo) => {
          if (
            mapCenterInfo &&
            mapCenterInfo.address &&
            mapCenterInfo.address.PlaceName &&
            mapCenterInfo.address.PlaceName.trim().toLowerCase() !==
            data.title.trim().toLowerCase()
          ) {
            props.dispatch({
              type: 'map/goToState',
              payload: data.title,
            })
          }
        },
      })
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    const query = value.toLowerCase();

    let searchResults = [];
    if (query !== '') {
      for (let searchableQuery in searchMap) {
        if (searchableQuery.indexOf(query) !== -1) {
          searchResults.push(...searchMap[searchableQuery]);
        }
      }
    }

    setResults(searchResults);
  };

  return (
    <div className={styles.searchBox}>
      <SelectSearch
        options={results}
        search
        onChange={handleResultSelect}
        // placeholder='Find Layer'
        renderValue={(valueProps) => {
          return (
            // <input  className='select-search__value-container' {...valueProps} value={query} onChange={handleSearchChange} />
            <div {...valueProps} className='select-search__value-container'>
              <div className='select-search__value-label'>
                <input value={query} placeholder='Search Layers' onChange={handleSearchChange} />
              </div>
              <Search width={20} />
            </div>
          );
        }}
        renderOption={(optionsProps, optionData, optionSnapshot) => {
          const optionTitle = optionData.title.replace('_', ' ')
          return (
            <button {...optionsProps} key={optionData.key} className={`select-search__option ${styles.searchResultItem}`}>
              <img src={`${props.assetsUrl}/states/icons/small/${STATES_DATA[optionTitle]?.abbrev.toLowerCase()}.png`} />
              <div className={styles.resultDetail}>
                <div className={styles.resultState}>{optionTitle}</div>
                <div className={styles.resultCategoryLayer}>{optionData.description}</div>
              </div>
            </button>
          );
        }}
      />
    </div>
  );
}

LayersSearchBox.propTypes = {
  assetsUrl: PropTypes.string,
  layers: PropTypes.array,
  loading: PropTypes.bool
}

export default LayersSearchBox
